export const CSOSN_DATA = [
    { value: '101', label: '101= Tributada pelo Simples Nacional com permissão de crédito' },
    { value: '102', label: '102= Tributada pelo Simples Nacional sem permissão de crédito' },
    { value: '103', label: '103= Isenção do ICMS no Simples Nacional para faixa de receita bruta' },
    { value: '201', label: '201= Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária' },
    { value: '202', label: '202= Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária' },
    { value: '203', label: '203= Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária' },
    { value: '300', label: '300= Imune' },
    { value: '400', label: '400= Não tributada pelo Simples Nacional' },
    { value: '500', label: '500= ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação' },
    { value: '900', label: '900= Outros' },
]
export const ICMS_CST = [
    { value: "00", label: "00= Tributada integralmente" },
    { value: "10", label: "10= Tributada e com cobrança do ICMS por substituição tributária" },
    { value: "20", label: "20= Com redução de base de cálculo" },
    { value: "30", label: "30= Isenta ou não tributada e com cobrança do ICMS por substituição tributária" },
    { value: "40", label: "40= Isenta" },
    { value: "41", label: "41= Não tributada" },
    { value: "50", label: "50= Suspensão" },
    { value: "51", label: "51=0 Diferimento" },
    { value: "60", label: "60= ICMS cobrado anteriormente por substituição tributária" },
    { value: "70", label: "70= Com redução de base de cálculo e cobrança do ICMS por substituição tributária" },
    { value: "90", label: "90= Outros" }
]

export const ICMS_DATA_GROUP = {
    "ICMS": [
        {
            display: 'Mod. BC do ICMS (Modalidade de determinação)',
            key: 'mod_bc',
            as: "select",
            default: "0",
            options: [
                {
                    "value": "0",
                    "label": "Margem Valor Agregado (%)"
                },
                {
                    "value": "1",
                    "label": "Pauta (Valor)"
                },
                {
                    "value": "2",
                    "label": "Preço Tabelado Máx. (valor)"
                },
                {
                    "value": "3",
                    "label": "Valor da operação"
                }
            ]
        },
        {
            display: "Base de Cálculo",
            key: "bc_icms",
            not_percent: true,
            prefix: "R$ "
        },
        {
            display: "Alíquota de ICMS (%)",
            key: "p_icms",
            prefix: "% "
        },
        {
            display: "Percentual da Redução de BC",
            key: "p_red_bc",
            prefix: "% "
        },
        {
            display: "Valor do ICMS",
            key: "v_icms",
            not_percent: true,
            prefix: "R$ "
        }
    ],
    "ST": [
        {
            display: 'Mod. BC do ICMS ST (Modalidade de determinação)',
            key: 'mod_bc_st',
            as: "select",
            default: "0",
            options: [
                {
                    "value": "0",
                    "label": "Preço tabelado ou máximo sugerido"
                },
                {
                    "value": "1",
                    "label": "Lista Negativa (valor)"
                },
                {
                    "value": "2",
                    "label": "Lista Positiva (valor)"
                },
                {
                    "value": "3",
                    "label": "Lista Neutra (valor)"
                },
                {
                    "value": "4",
                    "label": "Margem Valor Agregado (%)"
                },
                {
                    "value": "5",
                    "label": "Pauta (valor)"
                },
                {
                    "value": "6",
                    "label": "Valor da Operação"
                }
            ],
        },

        {
            display: "Base de Cálculo ICMS ST",
            key: "v_bc_st",
            not_percent: true,
            prefix: "R$ "
        },
        {
            display: "Alíquota ICMS ST",
            key: "p_icms_st",
            prefix: "% "
        },

        {
            display: "Percentual da Redução de BC ST",
            key: "p_red_bc_st",
            prefix: "% "
        },
        {
            display: "Valor do ICMS ST",
            key: "v_icms_st",
            not_percent: true,
            prefix: "R$ "
        },
        {
            display: "Percentual da margem de valor Adicionado do ICMS ST",
            key: "p_mva_st",
            prefix: "% "
        },


    ],
    "SN": [
        {
            display: "Alíquota ICMS SN",
            key: "p_cred_sn",
            prefix: "% "
        },
        {
            display: "Valor ICMS SN",
            key: "v_cred_icms_sn",
            not_percent: true,
            prefix: "R$ "
        },
    ],
    "RET": [
        {
            display: "BC ICMS ST Retido",
            key: "v_bc_st_ret",
            not_percent: true,
            prefix: "R$ "
        },
        {
            display: "Valor ICMS ST Retido",
            key: "v_icms_st_ret",
            not_percent: true,
            prefix: "R$ "
        }

    ]
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/ICMS/data.js